export {default as ar} from "./Resources.ar.json";
export {default as csCZ} from "./Resources.cs-CZ.json";
export {default as cs} from "./Resources.cs.json";
export {default as da} from "./Resources.da.json";
export {default as de} from "./Resources.de.json";
export {default as elGR} from "./Resources.el-GR.json";
export {default as es} from "./Resources.es.json";
export {default as fi} from "./Resources.fi.json";
export {default as fr} from "./Resources.fr.json";
export {default as id} from "./Resources.id.json";
export {default as is} from "./Resources.is.json";
export {default as itIT} from "./Resources.it-IT.json";
export {default as it} from "./Resources.it.json";
export {default as ja} from "./Resources.ja.json";
export {default as koKR} from "./Resources.ko-KR.json";
export {default as ko} from "./Resources.ko.json";
export {default as nb} from "./Resources.nb.json";
export {default as nnNO} from "./Resources.nn-NO.json";
export {default as nn} from "./Resources.nn.json";
export {default as no} from "./Resources.no.json";
export {default as pl} from "./Resources.pl.json";
export {default as pt} from "./Resources.pt.json";
export {default as en} from "./Resources.json";
export {default as skSK} from "./Resources.sk-SK.json";
export {default as sk} from "./Resources.sk.json";
export {default as sv} from "./Resources.sv.json";
export {default as th} from "./Resources.th.json";
export {default as vi} from "./Resources.vi.json";
export {default as zhHans} from "./Resources.zh-Hans.json";
export {default as zhHant} from "./Resources.zh-Hant.json";
export {default as zhHK} from "./Resources.zh-HK.json";
export {default as zhTW} from "./Resources.zh-TW.json";
export {default as zh} from "./Resources.zh.json";
export const countryCodes = ["ar","cs-CZ","cs","da","de","el-GR","es","fi","fr","id","is","it-IT","it","ja","ko-KR","ko","nb","nn-NO","nn","no","pl","pt","en","sk-SK","sk","sv","th","vi","zh-Hans","zh-Hant","zh-HK","zh-TW","zh"];
